import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { FeaturedMediaListLayer } from '../components/featuredMedia/FeaturedMediaListLayer'

export const FeaturedMediaList = () => {
  return (
    <MasterLayout>
        <FeaturedMediaListLayer />
    </MasterLayout>
  )
}
